import component    from './component/index';
import io           from './global/io';
import layout       from './layout/index';
import page         from './page/index';

export default {
  component,
  io,
  layout,
  page
}



// WEBPACK FOOTER //
// ./src/locales/no/index.js